/* ------------------------------------------------------------------ */
/*  Variant-order sorter                                              */
/*  – keeps rows sorted by data-variant-order                         */
/*  – exposes window.forceVariantRowSort() so you can call it anytime */
/* ------------------------------------------------------------------ */
(() => {

  const TABLE_ID = 'cumulative-variant-table';
  const RETRY_MS = 50;               // polling + debounce interval
  let currentObserver = null;        // so we can disconnect when table replaced

  /* sort helper – order only */
  function sortRowsIn(table) {
    const rows = [...table.querySelectorAll('#collection-list-row')];
    rows.sort(
      (a, b) => (+a.dataset.variantOrder || 999999) - (+b.dataset.variantOrder || 999999)
    );
    rows.forEach(r => table.appendChild(r));
    console.log('[VariantSorter] sorted', rows.length, 'rows');
  }

  /* run once, attach fresh observer to *current* table */
  function forceVariantRowSort() {
    // if a previous observer exists, kill it
    if (currentObserver) {
      currentObserver.disconnect();
      currentObserver = null;
    }

    const table = document.getElementById(TABLE_ID);
    if (!table) {
      console.log('[VariantSorter] table not found, retrying…');
      setTimeout(forceVariantRowSort, RETRY_MS);
      return;
    }

    // initial pass
    sortRowsIn(table);

    // observer for any later rows inside this table element
    let debounce;
    currentObserver = new MutationObserver(() => {
      clearTimeout(debounce);
      debounce = setTimeout(() => sortRowsIn(table), RETRY_MS);
    });
    currentObserver.observe(table, { childList: true, subtree: true });
  }

  /* expose to global scope &
     also run immediately for the first render */
  window.forceVariantRowSort = forceVariantRowSort;
  forceVariantRowSort();

})();
